import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `
    <div class="container">
      <div class="header">
        <div class="brand">
          <div class="logo"></div>
          <div>
            <h1 class="h1">AdmisiónPlus Builder</h1>
          </div>
        </div>
      </div>

      <router-outlet></router-outlet>

      <div class="hint" style="margin-top:14px;">
        Siguiente paso: drafts (LocalStorage/Firestore), passage, image_url, plantillas por curso, y export batch.
      </div>
    </div>
  `
})
export class AppComponent {}
